module.exports = __webpack_public_path__ + "img/detail-gonglue.d1630267.svg";